import { OfcTableDemo } from './demo/OfcTableDemo';

/** `#/ofc/demo`: the table with no match behind it. */
export function DemoScreen() {
  return <OfcTableDemo />;
}
